import $ from 'jquery';

$('.close-button').click(function () {
    $('.corona-container').hide();
    sessionStorage.setItem('hide-corona-modal', 'true');
});

$(document).ready(function () {
    if (!sessionStorage.getItem('hide-corona-modal')) {
        $('.corona-container').css('display', 'block');
    }
});
